import _classCallCheck from "/root/website/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/root/website/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/root/website/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/root/website/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/root/website/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import { throttle } from '@stickyroll/utils';
import { PureComponent } from 'react';

var Tracker = /*#__PURE__*/function (_PureComponent) {
  _inherits(Tracker, _PureComponent);

  var _super = _createSuper(Tracker);

  function Tracker() {
    var _this;

    _classCallCheck(this, Tracker);

    _this = _super.apply(this, arguments);
    /* istanbul ignore next */

    /**
     * Tracks the page scroll and calls the updateFunction
     * @protected
     * @return {void}
     */

    _this.trackScroll = function () {
      if (typeof _this.props.onUpdate === "function") {
        _this.props.onUpdate(window.scrollY);
      }
    };

    return _this;
  }
  /**
   * init.
   * @public
   */


  _createClass(Tracker, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.addHandlers();
    }
    /**
     * Update all event handlers if the throttle property changed.
     * @public
     * @param {IEventTrackerProps} oldProps
     * @return {void}
     */

  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(oldProps) {
      if (oldProps.throttle !== this.props.throttle) {
        this.updateHandlers();
      }
    }
    /**
     * Cleanup.
     * @public
     */

  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.removeHandlers();
    }
    /**
     * This component does not render anything.
     * @public
     */

  }, {
    key: "render",
    value: function render() {
      return null;
    }
    /**
     * Add event handlers.
     * On resize and orientation change throttle is enforced at `250ms`.
     */

  }, {
    key: "addHandlers",
    value: function addHandlers() {
      var eventHandler = this.props.throttle ? throttle(this.trackScroll, this.props.throttle) : this.trackScroll;
      var forceThrottle = throttle(this.trackScroll, 250);
      this.scrollHandler = document.addEventListener("scroll", eventHandler, {
        passive: true
      });
      this.resizeHandler = window.addEventListener("resize", forceThrottle, {
        passive: true
      });
      this.orientationHandler = window.addEventListener("orientationchange", forceThrottle, {
        passive: true
      });
    }
    /**
     * Remove event handlers.
     * @public
     */

  }, {
    key: "removeHandlers",
    value: function removeHandlers() {
      document.removeEventListener("scroll", this.scrollHandler);
      window.removeEventListener("resize", this.resizeHandler);
      window.removeEventListener("resize", this.orientationHandler);
    }
    /**
     * Update event handlers. Safely removes and re-adds all event handlers.
     * @public
     */

  }, {
    key: "updateHandlers",
    value: function updateHandlers() {
      this.removeHandlers();
      this.addHandlers();
    }
  }]);

  return Tracker;
}(PureComponent);

export { Tracker };